module.exports = __webpack_public_path__ + "static/media/16.986bd74c.jpg";